import { useEffect, useState } from "react";
import FileUploadButton from "../../../input/file-upload-btn";
import axios from "axios";
import qs from "qs";
import dataProvider from "../../../../../../../services/dataProvider";
import authServices from "../../../../../../../services/authServices";
import normalizeDate from "../../../../../../../utility/normalizeDate";
import DatePicker from "react-datepicker";

const InlineTabularForm = ({
    schema = {},
    data = [],
    isUpdating,
    onUpdate,
    onSubmit,
    onDelete,
    onFileView,
    disableAddRow = false,
}) => {
    const [displayData, setDisplayData] = useState(data);
    const [addFormData, setAddFormData] = useState({});
    const [editFormData, setEditFormData] = useState({});
    const [search, setSearch] = useState("");

    function searchArrayOfObject(arr, searchKey) {
        return arr.filter((obj) =>
            Object.keys(obj)
                .filter((k) => schema[k]?.searchable === true)
                .some((key) => obj[key]?.toString().toLowerCase().includes(searchKey.toLowerCase()))
        );
    }

    useEffect(() => {
        if (data.length === 0) {
            setDisplayData([]);
            return;
        }

        if (search !== "") {
            let searchResult = searchArrayOfObject(data, search);
            setDisplayData(searchResult);
        } else {
            setDisplayData(data);
        }
    }, [data, search]);

    useEffect(() => {
        if (!isUpdating) {
            setEditFormData({});
            setAddFormData({});
        }
    }, [isUpdating]);

    function handleSubmit(e) {
        e.preventDefault();
        onSubmit(addFormData);
    }

    function handleEditSubmit(e) {
        e.preventDefault();
        onUpdate(editFormData);
    }

    function handleDelete(e, row) {
        e.preventDefault();
        onDelete(row);
    }

    function setFile(file, field, stateUpdateFunction) {
        let fileDisplayNameKey = `${field}DisplayName`;
        //console.log(file, addFormData);
        stateUpdateFunction((fd) => ({
            ...fd,
            [field]: file,
            [fileDisplayNameKey]: file?.name || "",
        }));
    }

    function viewFile(fileName) {
        onFileView(fileName);
    }

    return (
        <div className="p-2 w-100 position-relative">
            <div className="d-flex mb-3">
                <div className="position-relative ms-auto w-100" style={{ maxWidth: "20rem" }}>
                    <input
                        type="text"
                        className="form-control w-100"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search"
                        style={{ height: "2.5rem", paddingRight: "2.5rem" }}
                    />
                    <div
                        className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center"
                        style={{ width: "2.5rem", height: "2.5rem" }}
                    >
                        <i className="material-icons text-black-50">search</i>
                    </div>
                </div>
            </div>

            <div className="position-relative">
                <div className="w-100 position-relative" style={{overflowX:"auto"}}>
                    <table  className="table table-hover table-responsive align-middle w-100 m-0">
                        <thead className="table-light text-2">
                            <tr className="text-2">
                                {/* Headers */}
                                {Object.keys(schema).map((field, i) => (
                                    <th style={{ borderBottom: "1.5px solid #ccc" }} key={i}>
                                        <div style={schema[field].style}>{schema[field].name}</div>
                                    </th>
                                ))}
                                <th style={{ borderBottom: "1.5px solid #ccc", minWidth: "8rem" }}>Operations</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayData.map((row, i) =>
                                editFormData.id === row.id ? (
                                    <tr key={i}>
                                        {Object.keys(schema).map((field, j) => (
                                            <td key={j} className="position-relative">
                                                {schema[field].type === "file" ? (
                                                    <FileUploadButton
                                                        setFile={setFile}
                                                        field={field}
                                                        file={editFormData[field]}
                                                        stateUpdateFunction={setEditFormData}
                                                    />
                                                ) : schema[field].type === "date1" ? (
                                                    <div className="position-relative">
                                                        <DatePicker
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            popperClassName="top"
                                                            selected={
                                                                isNaN(
                                                                    new Date(
                                                                        parseInt(editFormData[field + "InMilliSeconds"])
                                                                    ).getTime()
                                                                )
                                                                    ? null
                                                                    : new Date(
                                                                          parseInt(editFormData[field + "InMilliSeconds"])
                                                                      )
                                                            }
                                                            placeholderText="Enter Date"
                                                            onChange={(date) =>
                                                                setEditFormData((fs) => ({
                                                                    ...fs,
                                                                    [field]: normalizeDate(date.getTime()),
                                                                    [field + "InMilliSeconds"]: date.getTime(),
                                                                }))
                                                            }
                                                        />
                                                        <div className="datepicker-icon"></div>
                                                    </div>
                                                ) : (
                                                    <input
                                                        form="editInlineForm"
                                                        className="form-control"
                                                        type={schema[field].type}
                                                        name={field}
                                                        value={editFormData[field]||""}
                                                        onChange={(e) =>
                                                            setEditFormData((fd) => ({
                                                                ...fd,
                                                                [field]: e.target.value,
                                                            }))
                                                        }
                                                        placeholder={schema[field].placeholder || ""}
                                                        required
                                                    />
                                                )}
                                            </td>
                                        ))}
                                        <td className="d-flex">
                                            <form id="editInlineForm" onSubmit={handleEditSubmit}>
                                                <button className="btn btn-primary text-light w-100">Update</button>
                                            </form>
                                            <button
                                                className="btn btn-primary text-light w-100 ms-3"
                                                onClick={() => setEditFormData({})}
                                            >
                                                Cancel
                                            </button>
                                        </td>
                                    </tr>
                                ) : (
                                    <tr key={i}>
                                        {Object.keys(schema).map((field, j) => (
                                            <td className="py-3" key={j} style={schema[field].style}>
                                                {schema[field].type === "file" ? (
                                                    row[field] ? (
                                                        <div
                                                            className="cursor-pointer text-primary"
                                                            onClick={() => viewFile(row[field])}
                                                        >
                                                            View File
                                                        </div>
                                                    ) : (
                                                        <div>No File</div>
                                                    )
                                                ) : (
                                                    row[field] || "-"
                                                )}
                                            </td>
                                        ))}
                                        <td className="py-3 d-flex">
                                            <div
                                                className="link-primary cursor-pointer"
                                                onClick={() => {
                                                    setEditFormData(row);
                                                }}
                                            >
                                                Edit
                                            </div>
                                            <div
                                                className="link-primary cursor-pointer ms-3"
                                                onClick={(e) => {
                                                    handleDelete(e, row);
                                                }}
                                            >
                                                Delete
                                            </div>
                                        </td>
                                    </tr>
                                )
                            )}
                            {displayData.length === 0 && (
                                <tr>
                                    <td
                                        className="text-center"
                                        style={{ height: "4rem" }}
                                        colSpan={Object.keys(schema).length + 1}
                                    >
                                        Empty Form
                                    </td>
                                </tr>
                            )}
                            {/* Add Data Row  */}

                            {!disableAddRow && (
                                <tr>
                                    {Object.keys(schema).map((field, j) => (
                                        <td key={j} className="position-relative">
                                            {schema[field].type === "file" ? (
                                                <FileUploadButton
                                                    setFile={setFile}
                                                    field={field}
                                                    file={addFormData[field]}
                                                    stateUpdateFunction={setAddFormData}
                                                />
                                            ) : schema[field].type === "date1" ? (
                                                <div className="position-relative">
                                                    <DatePicker
                                                        dateFormat="dd/MM/yyyy"
                                                        className="form-control"
                                                        selected={
                                                            isNaN(
                                                                new Date(
                                                                    parseInt(addFormData[field + "InMilliSeconds"])
                                                                ).getTime()
                                                            )
                                                                ? null
                                                                : new Date(
                                                                      parseInt(addFormData[field + "InMilliSeconds"])
                                                                  )
                                                        }
                                                        placeholderText="Enter Date"
                                                        onChange={(date) =>
                                                            setAddFormData((fs) => ({
                                                                ...fs,
                                                                [field]: normalizeDate(date.getTime()),
                                                                [field + "InMilliSeconds"]: date.getTime(),
                                                            }))
                                                        }
                                                    />
                                                    <div className="datepicker-icon"></div>
                                                </div>
                                            ) : (
                                                <input
                                                    form="addInlineForm"
                                                    className="form-control"
                                                    type={schema[field].type}
                                                    name={field}
                                                    value={addFormData[field]||""}
                                                    onChange={(e) =>
                                                        setAddFormData((fd) => ({
                                                            ...fd,
                                                            [field]: e.target.value,
                                                        }))
                                                    }
                                                    placeholder={schema[field].placeholder || ""}
                                                    required
                                                />
                                            )}
                                        </td>
                                    ))}
                                    <td>
                                        <form id="addInlineForm" onSubmit={handleSubmit}>
                                            <button
                                                className="btn btn-primary text-light w-100"
                                                disabled={!!editFormData.id}
                                            >
                                                Add
                                            </button>
                                        </form>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {isUpdating && (
                    <div
                        className="position-absolute top-0 w-100 h-100 d-flex align-items-center justify-content-center"
                        style={{ background: "#0001" }}
                    >
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default InlineTabularForm;
